import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import * as React from 'react';

var createTimer = function createTimer(props) {
  var _props$repeat = props.repeat,
    repeat = _props$repeat === void 0 ? false : _props$repeat,
    delay = props.delay,
    callback = props.callback;
  if (repeat) {
    var _timer = setInterval(callback, delay);
    return {
      destroy: function destroy() {
        return clearInterval(_timer);
      }
    };
  }
  var timer = setTimeout(callback, delay);
  return {
    destroy: function destroy() {
      return clearTimeout(timer);
    }
  };
};
var resolveDeps = function resolveDeps(props) {
  return [props.callback, props.delay, props.repeat];
};
var useTimer = function useTimer(props) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var timer = React.useRef();
  React.useEffect(function () {
    timer.current = createTimer(props);
    return function () {
      var _timer$current;
      return (_timer$current = timer.current) === null || _timer$current === void 0 ? void 0 : _timer$current.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [].concat(_toConsumableArray(resolveDeps(props)), _toConsumableArray(dependencies)));
  return {
    destroy: function destroy() {
      var _timer$current2;
      return (_timer$current2 = timer.current) === null || _timer$current2 === void 0 ? void 0 : _timer$current2.destroy();
    }
  };
};

export { createTimer, useTimer };
//# sourceMappingURL=timer.js.map
